import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useSession } from 'next-auth/react';
import { useCallback, useState, useEffect, FormEvent } from 'react';
import { Button, TextField } from 'components/base';

import Auth from 'clients/Firebase';

import podsLogo from 'public/images/pods-logo-2.png';
import Page from 'components/wrappers/Page';

const Password: NextPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasResetLinkSent, setHasResetLinkSent] = useState(false);

  const user = useSession();
  const router = useRouter();

  const [email, setEmail] = useState('');

  const _sendResetPasswordLink = useCallback(
    (e: FormEvent | MouseEvent) => {
      e.preventDefault();
      setIsLoading(true);
      const send = async () => {
        await sendPasswordResetEmail(Auth, email, {
          url: `${window.location.href}/login/password/reset`
        });

        setHasResetLinkSent(true);
      };

      send();
    },
    [email]
  );

  useEffect(() => {
    if (user.status === 'authenticated') router.push('/');
  }, [user, router]);

  return (
    <Page className="Password" title="Reset Password - PODS">
      <div className="fixed top-0 left-0 right-0 bottom-0 bg-stone-900 flex flex-col items-center justify-center">
        <div className="Password__logo relative w-[188px] mb-12">
          <Image src={podsLogo} alt="PODS" />
        </div>
        <div className="flex rounded-sm bg-white p-5 drop-shadow-sm flex-col items-center w-[360px]">
          <form className="flex w-full">
            <div className="flex flex-col w-full">
              {hasResetLinkSent ? (
                <div className="flex flex-col">
                  <span>
                    Please check <span className="underline">{email}</span> for a message containing
                    a reset password link.
                  </span>
                </div>
              ) : (
                <>
                  <div className="mb-6 flex flex-col">
                    <TextField
                      placeholder="example@escapod.us"
                      label="Email"
                      ariaLabel="Email"
                      id="login_email"
                      type="text"
                      name="email"
                      onChange={value => setEmail(value as string)}
                    />
                  </div>
                  <Button
                    variant="secondary"
                    onClick={_sendResetPasswordLink}
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Resetting...' : 'Send Reset Link'}
                  </Button>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </Page>
  );
};

export default Password;
